var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 2.5,
    fill: "#FFF0D6",
    stroke: "#EDE8E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8702_631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0776 30.1309L48.9422 32.0922L46.9202 61.3158H28.6799L27.1668 39.4471L26.6578 32.0922L26.5225 30.1309H49.0776Z",
    fill: "#00E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5225 30.1309L26.6578 32.0922H43.6349V39.4472H41.7423L42.7102 48.3339C42.4966 48.137 42.2623 47.962 42.009 47.8161C41.3117 43.0874 37.2272 39.4472 32.3083 39.4472H27.1667L28.6799 61.3159H40.4135C40.7959 60.9206 41.1205 60.4774 41.3803 59.9979C41.6225 59.5517 41.8069 59.0761 41.9305 58.5838C42.2561 58.4063 42.5592 58.1808 42.8288 57.9111C43.1674 57.5729 43.4356 57.1832 43.628 56.7601L44.1242 61.316H46.9201L48.942 32.0924H48.9422L49.0078 31.1435L49.0099 31.1117L49.0776 30.1311L26.5225 30.1309Z",
    fill: "#40C4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1538 57.0996C40.1538 57.8096 39.9743 58.4784 39.6576 59.0609C39.4673 59.412 39.2281 59.7317 38.9476 60.0122C38.2023 60.7575 37.1726 61.2184 36.035 61.2184H21.7174C20.1522 61.2184 18.7921 60.3467 18.0948 59.061C17.778 58.4785 17.5986 57.8097 17.5986 57.0997H40.1538V57.0996Z",
    fill: "#FDD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1538 57.0996C40.1538 57.8096 39.9743 58.4784 39.6576 59.0609H18.0948C17.778 58.4784 17.5986 57.8096 17.5986 57.0996H40.1538Z",
    fill: "#FFC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.017 55.1372C42.017 55.6785 41.7974 56.1688 41.4423 56.5238C41.0873 56.8788 40.597 57.0985 40.0557 57.0985H17.6967C16.6131 57.0985 15.7354 56.2208 15.7354 55.1372C15.7354 54.6272 15.9305 54.1624 16.2502 53.8133C16.2688 53.7917 16.2895 53.7711 16.3101 53.7505C16.665 53.3955 17.1554 53.1758 17.6967 53.1758H40.0557C40.6696 53.1758 41.2178 53.4572 41.5767 53.8995C41.8523 54.2369 42.017 54.6685 42.017 55.1372Z",
    fill: "#FF9017"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5765 53.8996L37.0507 57.0985H20.8974L16.25 53.8133C16.2687 53.7917 16.2893 53.7711 16.3099 53.7505C16.6648 53.3955 17.1552 53.1758 17.6965 53.1758H40.0555C40.6694 53.1759 41.2176 53.4573 41.5765 53.8996Z",
    fill: "#FF7043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.017 51.2152C42.017 51.7565 41.7974 52.2469 41.4423 52.6018C41.0874 52.9568 40.597 53.1766 40.0557 53.1766H17.6967C16.6131 53.1766 15.7354 52.2988 15.7354 51.2152C15.7354 50.6739 15.955 50.1836 16.3101 49.8286C16.665 49.4736 17.1554 49.2539 17.6967 49.2539H40.0557C41.1393 49.2539 42.017 50.1316 42.017 51.2152Z",
    fill: "#B0EF60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2026 53.1758H18.7461L25.8216 58.1771L28.9744 55.9485L32.1272 58.1771L39.2026 53.1758Z",
    fill: "#FDD844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8966 53.1758L30.1222 55.1371L28.9739 55.9481L27.2744 57.1494L26.6938 56.7395L21.6533 53.1758H32.8966Z",
    fill: "#FDAB08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2026 53.1758L36.4284 55.1371H21.5204L18.7461 53.1758H39.2026Z",
    fill: "#FDAB08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1551 14.2548V14.3519C45.1551 15.0354 44.6844 15.6287 44.0184 15.7836L39.2711 16.8917V23.3641H36.3291V14.5382L43.3349 12.826C44.2617 12.5995 45.1551 13.3006 45.1551 14.2548Z",
    fill: "#FDD844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8617 51.2152H16.8918C16.1762 51.2152 15.7975 50.3491 16.2997 49.8393C16.3032 49.8357 16.3067 49.8321 16.3102 49.8286C16.6652 49.4736 17.1556 49.2539 17.6969 49.2539H40.0559C40.6033 49.2539 41.0983 49.4779 41.454 49.8393C41.9559 50.3493 41.5773 51.2152 40.8617 51.2152Z",
    fill: "#64DD17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1538 49.2534H17.5986C17.5986 48.5758 17.685 47.9187 17.8458 47.2921C18.2008 45.9133 18.9206 44.6815 19.8964 43.7059C21.3164 42.2868 23.2777 41.4082 25.4439 41.4082H32.3086C35.9634 41.4082 39.0359 43.9089 39.9067 47.2922C40.0674 47.9187 40.1538 48.5758 40.1538 49.2534Z",
    fill: "#FDD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5387 33.0723H45.5967V49.4493H48.5387V33.0723Z",
    fill: "#FDD844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4312 35.2305H48.4893V51.6075H51.4312V35.2305Z",
    fill: "#FDD844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3736 33.0723H51.4316V49.4493H54.3736V33.0723Z",
    fill: "#FDD844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.315 35.2305H54.373V51.6075H57.315V35.2305Z",
    fill: "#FDD844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2574 35.2305H57.3154V51.6075H60.2574V35.2305Z",
    fill: "#FDD844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1998 31.9941H60.2578V48.3712H63.1998V31.9941Z",
    fill: "#FDD844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2711 21.4023H36.3291V23.3637H39.2711V21.4023Z",
    fill: "#FDAB08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2936 26.6975H27.3076L27.9421 24.7361L28.3863 23.3633H47.2149L47.6591 24.7361L48.2936 26.6975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1995 39.4473V48.3713H60.2575V51.6074H54.3735V49.45H51.4316V51.6074H48.4896V49.45H45.5967V39.4473H48.4484L48.4896 39.562L48.5387 39.6992L50.5568 45.3311H57.5528L59.6613 39.4473H63.1995Z",
    fill: "#FDAB08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0422 41.4082L58.9338 47.2921H49.1762L47.0678 41.4082H43.9297L46.0871 61.2174H62.0228L64.1802 41.4082H61.0422Z",
    fill: "#F4511E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2936 26.6977H27.3076L27.9421 24.7363H47.6591L48.2936 26.6977Z",
    fill: "#D8D7DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0393 30.1296H24.5615L25.6402 26.6973H49.9606L51.0393 30.1296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1538 49.2543H17.5986C17.5986 48.5767 17.685 47.9196 17.8458 47.293H39.9067C40.0674 47.9196 40.1538 48.5767 40.1538 49.2543Z",
    fill: "#FFC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7255 58.2758L47.8496 50.2344H60.2591L59.3833 58.2758H48.7255Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7526 51.2144C42.7526 50.01 41.9589 48.9879 40.8673 48.6426C40.5532 44.195 36.8347 40.6723 32.3086 40.6723H27.9892L27.3108 30.8657H52.0412L50.5002 25.9624H48.8284L47.7496 22.6281H40.0068V17.4751L44.1856 16.5C45.1896 16.2657 45.8908 15.3821 45.8908 14.3512V14.2542C45.8908 13.5722 45.5831 12.9397 45.0468 12.5186C44.5104 12.0976 43.8228 11.949 43.1605 12.1108L35.5938 13.9604V22.6283H27.851L26.7722 25.9626H25.1004L23.5594 30.8659H25.8363L26.5147 40.6725H25.4439C20.9177 40.6725 17.1993 44.1952 16.8852 48.6428C15.7937 48.9879 15 50.0102 15 51.2144C15 51.9866 15.3269 52.6836 15.8487 53.1757C15.3269 53.6678 15 54.3647 15 55.137C15 56.3481 15.8025 57.3752 16.9037 57.7146C17.2077 60.1012 19.2497 61.9525 21.7175 61.9525H36.0351C38.5029 61.9525 40.545 60.1012 40.8489 57.7146C41.95 57.3751 42.7526 56.3481 42.7526 55.137C42.7526 54.3647 42.4257 53.6678 41.9039 53.1757C42.4257 52.6836 42.7526 51.9866 42.7526 51.2144ZM37.0648 15.1152L43.5096 13.5398C43.7304 13.4858 43.9596 13.5354 44.1384 13.6758C44.3172 13.8161 44.4198 14.027 44.4198 14.2543V14.3512C44.4198 14.6949 44.186 14.9893 43.8514 15.0676L38.5359 16.3078V22.6283H37.0649V15.1152H37.0648ZM28.9211 24.0992H46.6796L47.2824 25.9625H28.3183L28.9211 24.0992ZM25.5636 29.3948L26.18 27.4335H49.4205L50.0369 29.3948H25.5636ZM25.444 42.1433H32.3087C35.9806 42.1433 39.0115 44.9416 39.3807 48.5176H18.372C18.7412 44.9416 21.7721 42.1433 25.444 42.1433ZM17.6968 49.9886H40.0558C40.7318 49.9886 41.2816 50.5385 41.2816 51.2144C41.2816 51.8903 40.7317 52.4401 40.0558 52.4401H17.6968C17.0208 52.4401 16.471 51.8902 16.471 51.2144C16.471 50.5384 17.0208 49.9886 17.6968 49.9886ZM32.1272 57.2764L27.3664 53.9111H36.888L32.1272 57.2764ZM27.7002 55.9485L25.8216 57.2765L21.0607 53.9112H24.818L27.7002 55.9485ZM16.471 55.137C16.471 54.461 17.0209 53.9112 17.6968 53.9112H18.5123L21.9806 56.3629H17.6968C17.0208 56.3628 16.471 55.813 16.471 55.137ZM36.0351 60.4816H21.7175C20.1045 60.4816 18.7515 59.3469 18.4147 57.8339H24.0617L25.8216 59.0778L28.9744 56.8492L32.1273 59.0778L33.8872 57.8339H39.3379C39.0011 59.3469 37.6481 60.4816 36.0351 60.4816ZM41.2816 55.137C41.2816 55.813 40.7317 56.3628 40.0558 56.3628H35.9681L39.4365 53.9111H40.0557C40.7318 53.9112 41.2816 54.461 41.2816 55.137Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9348 40.6721V31.2578H59.5218V34.4939H55.1089V32.3365H50.6959V34.4939H49.2739V32.3365H44.8609V40.6721H43.1094L45.427 61.9524H62.6822L64.9999 40.6721H63.9348ZM60.9929 32.7288H62.4639V40.6721H60.9929V32.7288ZM59.5219 35.965V43.4693L58.4159 46.5561H58.0509V35.965H59.5219ZM56.58 35.965V46.5561H55.109V35.965H56.58ZM52.167 33.8075H53.638V46.5561H52.167V33.8075ZM50.696 35.965V46.5561H49.6936L49.274 45.385V35.965H50.696ZM46.332 33.8075H47.803V41.2799L47.5852 40.6721H46.332V33.8075ZM61.3628 60.4815H46.7467L44.7495 42.1431H46.5499L48.6583 48.0271H59.4513L61.5597 42.1431H63.3601L61.3628 60.4815Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0664 59.0104H60.0436L61.0796 49.498H47.0303L48.0664 59.0104ZM59.4396 50.969L58.724 57.5394H49.3856L48.67 50.969H59.4396Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1497 43.7129H23.6787V45.1839H25.1497V43.7129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1243 44.5957H26.6533V46.0667H28.1243V44.5957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0989 44.5957H29.6279V46.0667H31.0989V44.5957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0735 43.7129H32.6025V45.1839H34.0735V43.7129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8398 33.8089H38.893V32.3379H40.8398V33.8089ZM37.422 33.8089H29.6748V32.3379H37.422V33.8089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6827 54.9905H56.3098V53.5195H57.6827V54.9905ZM54.8388 54.9905H53.3678V53.5195H54.8388V54.9905ZM51.8968 54.9905H50.4258V53.5195H51.8968V54.9905Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8702_631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(15 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodicon);
export default __webpack_public_path__ + "static/media/foodicon.4e4123aecd1c830392b5d36837ec01af.svg";
export { ForwardRef as ReactComponent };